// The auth method as a person writes it. Shared so the session-limit screen and
// the audit log cannot spell the same value differently.
const KNOWN_AUTH_METHODS = ["local", "saml", "ldap", "apikey"] as const;

export function authMethodLabel(t: (key: string) => string, method: string): string {
  const known = KNOWN_AUTH_METHODS.find((m) => m === method);
  // An unrecognised value is shown as the server sent it: inventing a label for
  // it would hide what the record actually says.
  return known ? t(`sessionLimit.authMethods.${known}`) : method;
}
